import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Observable } from 'rxjs/Rx';

import { ApiService } from './api.service';

@Injectable()
export class SpecieService extends ApiService {
  constructor(private http: Http) {
    super('api/species/', http);
  }

  get_species_association(): Observable<Object> {
    const url = this.apiUrl + `api/species-capture-map/get_species_association`;
    return this.http.get(url, { headers: this.getHeaders() }).map(this.extractData).catch(this.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/specie.service.ts